import GoogleAutocomplete from 'Base/classes/GoogleAutocomplete';
import Dispatch from 'Base/classes/Dispatch';
import Quote from 'Base/classes/Quote';

export default (id, location = '') => ({
    id: id,
    address: null,
    start_time_id: null,
    autocomplete: {
        google: new GoogleAutocomplete(),
        search: location,
        results: []
    },
    loading: false,
    init(startTimeId)
    {
        if (this.autocomplete.search) {
            this.locationSearch()
                .then(() => {
                    if (this.autocomplete.results.length > 0) {
                        this.setLocation(this.autocomplete.results[0]);
                    }
                })
                .catch(() => this.autocomplete.search = '');
        }

        if(startTimeId)
        {
            this.start_time_id = startTimeId
        }
    },
    isValid()
    {
        return this.id && this.start_time_id && (this.address || this.prediction());
    },
    back()
    {
        new Dispatch(this, 'quote-previous-step', {step: 2});
    },
    save()
    {
        window.googleAnalyticsManager.pushEvent(window.googleAnalyticsManager.events.QUOTE_STEP, {
            step_name : 'location-availabilty'
        });
        if ( this.address ) {
            this.nextStep();
        }
    },
    nextStep()
    {

        new Quote(this.id).step2({
            start_time_id: this.start_time_id,
            address: this.address
        }).then(() => {
            new Dispatch(this, 'quote-next-step', {step: 2});
        }).catch((response) => {
            console.log(response);
        });
    },
    locationSearch()
    {
        this.address = null;
        
        return this.autocomplete.google.search(this.autocomplete.search)
            .then(results => {
                this.autocomplete.results = results;
            })
            .catch(() => this.autocomplete.results = []);
    },
    prediction()
    {
        return (this.autocomplete.results.length > 0 && this.autocomplete.search.length > 2 ) ? [...new Map(this.autocomplete.results.map(obj => [obj.description, obj])).values()] : null;
    },
    setLocation(location)
    {
        if ( ! location ) {
            return;
        }
        this.autocomplete.results = [];
        this.autocomplete.search = location.description

        return new Promise((resolve) => {
            location.details()
                .then((data) => {
                    this.address = data;
                    resolve();
                })
        });
    },
});